import React from 'react';

export const MissingPermissionError = () => (
    <div>
        Für die Anzeige fehlen Ihnen notwendige Berechtigungen. Bitte fragen Sie Ihren Administrator um Hilfe
    </div>
)
